import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';
import { UsuarioService } from '../services/service.index';
import { Usuario } from '../models/usuario.model';
import { Router } from '@angular/router';

declare function init_plugins();

@Component({
  standalone: false,
  selector: 'app-recpassword',
  templateUrl: './recpassword.component.html',
  styleUrls: ['./login.component.css']
  
})
export class RecpasswordComponent implements OnInit {
  forma: FormGroup;
  buttonDisabled: boolean;
  constructor(
    public _usuarioService: UsuarioService,
    public router:Router
  ) { }

  ngOnInit() {
    init_plugins();
    this.buttonDisabled = true;
    this.forma = new FormGroup({
      correo: new FormControl( null , [Validators.required, Validators.email] )
    } );
  }

recuperarPassword(){
  this.buttonDisabled = false;
  if ( this.forma.invalid ) {
    Swal.fire('Importante', 'Debe ingresar el correo electronico', 'warning');
    return;
  }
  let usuario = new Usuario("","","");
  usuario.email=this.forma.value.correo;
  this._usuarioService.recuperaPAssword( usuario )
  .subscribe( resp => {
    this.buttonDisabled = true;
    this.router.navigate(['/login'])
  });
  

}

}
